import React from "react";
import { usePageLoading } from "../utility/loadingBar";
import "./Loader.css";

// The spinner. A page's own (not one inside a button, className "btnLoader",
// nor bar={false}) also runs the portal's loading bar (utility/loadingBar).
const Loader = ({ className = "", bar = true }) => {
  usePageLoading(bar && !/btnLoader/.test(className));
  return <div className="loader" />;
};

export default Loader;
